export const WINDOW_RESIZE = 'WINDOW_RESIZE';
export const WINDOW_SCROLL = 'WINDOW_SCROLL';
